import twClasses from '@/utils/twClasses';
import { NavMenu } from '@/components';
import clsx from 'clsx';
import HeaderTop from './HeaderTop';
import { HeaderSkeleton } from '../Skeletons/Skeletons';
import HeaderMessage from './HeaderMessage';
import {
    NAV_LINKS_QUERYResult,
    COMPANY_DETAILS_QUERYResult,
    HEADER_MESSAGE_CONTENT_QUERYResult,
} from 'sanity.types';

export interface NavItemsProps {
    active: boolean;
    desktopNav: boolean;
    desktopOrder: number;
    label: string;
    mobileNav: boolean;
    mobileOrder: number;
    path: string;
    mobileMenuIcon: string;
}
export type NavItem = NonNullable<NAV_LINKS_QUERYResult>[number];

interface HeaderProps {
    headerNavLinks: NAV_LINKS_QUERYResult;
    companyDetails: COMPANY_DETAILS_QUERYResult;
    headerTopMessage: HEADER_MESSAGE_CONTENT_QUERYResult;
}

const Header = ({
    headerNavLinks,
    companyDetails,
    headerTopMessage,
}: HeaderProps) => {
    const navLinks = (headerNavLinks ?? [])
        .filter((link): link is NavItem => !!link)
        .sort((a, b) => (a.desktopOrder ?? 0) - (b.desktopOrder ?? 0));

    const componentClasses = clsx(
        'pt-4',
        `${twClasses.flexCenterAll}`,
        'flex-wrap',
        'w-full'
    );

    if (!headerTopMessage[0] || navLinks.length === 0) {
        return <HeaderSkeleton />;
    }

    const { showHeaderMessage, message } = headerTopMessage[0];

    return (
        <>
            {showHeaderMessage && message ? (
                <HeaderMessage headerTopMessage={headerTopMessage} />
            ) : null}
            <header className={componentClasses}>
                <div className="flex justify-center relative w-full flex-wrap max-w-[900px] mx-4">
                    <HeaderTop
                        navLinks={navLinks}
                        topCompanyDetails={companyDetails}
                    />

                    <div className="gap-8 items-center text-gray-900 w-full justify-center flex-wrap py-2 border-t-4 border-[#A3C159] hidden md:flex">
                        <NavMenu
                            links={navLinks.filter((item) => !!item.desktopNav)}
                        />
                    </div>
                </div>
            </header>
        </>
    );
};

export default Header;
